<div class="section-style d-print-none">
  <div class="container">
    <markant-button (click)="location.back()">Zurück</markant-button>
    <div class="button-align">
      <div class="valignhelper">
        <app-product-nav direction="left"></app-product-nav>
      </div>
      <div class="centralInfo" *minPrivilege="'FULL'">
        <div *ngIf="productId$ | async as productId">
          <a class="ma-edit" [routerLink]="getProductEditRoute(productId)" style="color: red">
            <markant-button>&#9888; Produktseite bearbeiten &#9888; </markant-button>
          </a>
        </div>
        <div *ngIf="application$ | async | option as app">
          <div *ngIf="productId$ | async as productId">
            <div *ngIf="approveOrResetApplicationPossible(app); else showState">
              <div class="subheadline-text">{{ app.cycle.name }}</div>
              <div *ngIf="approveApplicationPossible(app); else resetOnly">
                <div class="confirmcancel">
                  <a class="voteButtons" (click)="approve(productId, app.cycle.uuid)"> Bestätigen</a>
                  <a class="voteButtons" (click)="resetRequest(productId, app.cycle.uuid)">Anforderung zurücknehmen</a>
                  <a class="voteButtons" (click)="reject(productId, app.cycle.uuid)"> Ablehnen</a>
                </div>
              </div>
            </div>
            <ng-template #resetOnly>
              <div class="confirmcancel">
                <a class="voteButtons" (click)="resetRequest(productId, app.cycle.uuid)">Anforderung zurücknehmen</a>
              </div>
            </ng-template>
            <ng-template #showState>
              <div style="margin: 0 20px; text-align: center" class="subheadline-text">
                {{ app.cycle.name }}
                <ng-container *ngIf="app.cycle.name">:</ng-container>
                {{ app.productStatus | productStateTranslate }}
              </div>
            </ng-template>
          </div>
        </div>
        <div *ngIf="productId$ | async as productId">
          <ng-container *ngIf="favoriteProduct$ | async; else addFavoriteProduct">
            <button class="infoButton active" (click)="deleteFavoriteProduct(productId)">Favorit entfernen</button>
          </ng-container>
          <ng-template #addFavoriteProduct>
            <button class="infoButton" (click)="setFavoriteProduct(productId)">Favorit hinzufügen</button>
          </ng-template>
        </div>
      </div>
      <div class="valignhelper">
        <app-product-nav direction="right"></app-product-nav>
      </div>
    </div>
  </div>
</div>
<ng-container *ngFor="let productId of productId$ | async | singleton">
  <app-product-view [productId]="productId">
    <div class="product-view-sub-contact d-print-none" style="padding-top: 1rem">
      <app-order-sample-button [productId]="productId"></app-order-sample-button>
    </div>
  </app-product-view>
</ng-container>
